import React from "react";
import StockManager from "./StockManager.js";
import "./App.css";

function App() {
  return (
    <div className="App">
      <h1>Stock Management</h1>
      <StockManager />
    </div>
  );
}

export default App;
